export const QR_VALUE_MAX_CHARACTERS = 180;
export const QR_LINE_MAX_CHARACTERS = 24;

export const QR_LABEL_PRESETS = [
  {
    id: "clean",
    name: "Ren QR-kode",
    description: "Kun QR-koden, uten tekst",
    value: "https://www.navnlapp.no",
    topLine: "",
    bottomLine: "",
  },
  {
    id: "scan-me",
    name: "Skann meg",
    description: "Tydelig oppfordring over koden",
    value: "https://www.navnlapp.no",
    topLine: "SKANN MEG",
    bottomLine: "",
  },
  {
    id: "if-found",
    name: "Hvis funnet",
    description: "For utstyr og eiendeler",
    value: "https://www.navnlapp.no",
    topLine: "HVIS FUNNET",
    bottomLine: "SKANN FOR KONTAKT",
  },
  {
    id: "product-info",
    name: "Produktinfo",
    description: "Lenke til informasjon eller nettside",
    value: "https://www.navnlapp.no",
    topLine: "PRODUKTINFO",
    bottomLine: "SKANN FOR Å LESE",
  },
  {
    id: "instructions",
    name: "Bruksanvisning",
    description: "Lenke til guide eller dokumentasjon",
    value: "https://www.navnlapp.no",
    topLine: "BRUKSANVISNING",
    bottomLine: "SKANN FOR GUIDE",
  },
  {
    id: "contact",
    name: "Kontakt oss",
    description: "Rask vei til kontaktsiden",
    value: "https://www.navnlapp.no",
    topLine: "KONTAKT OSS",
    bottomLine: "SKANN HER",
  },
];

export const QR_LABEL_SIZES = [
  {
    value: "small",
    label: "Liten",
    description: "70 lapper per sett",
    widthMm: 25,
    heightMm: 25,
    qrSizeMm: 17,
    columns: 7,
    rows: 10,
    gapMm: 1,
    labelsPerSet: 70,
  },
  {
    value: "medium",
    label: "Medium",
    description: "54 lapper per sett",
    widthMm: 30,
    heightMm: 30,
    qrSizeMm: 21,
    columns: 6,
    rows: 9,
    gapMm: 1,
    labelsPerSet: 54,
  },
  {
    value: "large",
    label: "Stor",
    description: "24 lapper per sett",
    widthMm: 45,
    heightMm: 45,
    qrSizeMm: 33,
    columns: 4,
    rows: 6,
    gapMm: 1.5,
    labelsPerSet: 24,
  },
];

export function normalizeQrValue(value) {
  const normalized = String(value ?? "").trim();
  if (!normalized) return "";
  if (/^(?:www\.)?[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z]{2,})(?:[/:?#].*)?$/i.test(normalized)) {
    return /^https?:\/\//i.test(normalized) ? normalized : `https://${normalized.replace(/^www\./i, "www.")}`;
  }
  return normalized;
}

export function resolveQrLabelSpec(template, designOrResponses = {}) {
  const sizeOptions = template?.sizeOptions?.length ? template.sizeOptions : QR_LABEL_SIZES;
  const responses = designOrResponses.responses || designOrResponses;
  const sizeField = (template?.fields || []).find((field) => field.role === "labelSize");
  const requested = responses?.[sizeField?.id] || sizeField?.defaultValue || template?.defaultSizeValue || "medium";
  const selected = sizeOptions.find((option) => option.value === requested) || sizeOptions[0];
  return {
    ...selected,
    widthMm: Number(selected.widthMm),
    heightMm: Number(selected.heightMm),
    qrSizeMm: Number(selected.qrSizeMm),
    columns: Number(selected.columns),
    rows: Number(selected.rows),
    gapMm: Number(selected.gapMm),
    labelsPerSet: Number(selected.labelsPerSet),
  };
}

export function labelSpecForDesign(template, design = {}) {
  if (template?.outputLayout === "qr-label-sheet") return resolveQrLabelSpec(template, design);
  return {
    widthMm: Number(template?.widthMm),
    heightMm: Number(template?.heightMm),
    columns: Number(template?.columns),
    rows: Number(template?.rows),
    gapMm: Number(template?.gapMm),
    labelsPerSet: Number(template?.labelsPerSet),
  };
}
